/**Controlador para conectar con el backend */
class Main {

    private static _instance: Main;

    private sections = [
        {
            name: 'Acerca del hotel',
            img: 'post1.png',
            url: '',
            size: 1
        },
        {
            name: 'Habitaciones',
            img: 'post2.png',
            url: '',
            size: 1
        },
        {
            name: 'Restaurantes & Bares',
            img: 'post3.png',
            url: '',
            size: 2
        }
    ];

    private sections2 = [
        {
            name: 'Servicio a la habitación',
            img: 'post4.png',
            url: '',
            size: 1
        },
        {
            name: 'Experiencias Románticas',
            img: 'post5.png',
            url: '',
            size: 1
        },
        {
            name: 'Actividades de Hotel',
            img: 'post6.png',
            url: '',
            size: 1
        },
        {
            name: 'Kids Club',
            img: 'post7.png',
            url: '',
            size: 1
        },
        {
            name: 'Spa',
            img: 'post8.png',
            url: '',
            size: 1
        },
        {
            name: 'Fitness Center',
            img: 'post9.png',
            url: '',
            size: 1
        }
    ];

    private sections3 = [
        {
            name: 'Tours & Excursiones',
            img: 'post10.png',
            url: '',
            size: 3
        },
        {
            name: 'Puntos Cercanos',
            img: 'post11.png',
            url: '',
            size: 3
        }
    ];

    private restaurants = [
        {
            title: 'Champions Sports Bar',
            type: 'Cocina Internacional',
            images: [
                '/assets/img/restaurant1.png',
                '/assets/img/restaurant2.png',
                '/assets/img/restaurant3.png',
                '/assets/img/restaurant4.png',
                '/assets/img/restaurant5.png',
                '/assets/img/restaurant6.png',
                '/assets/img/restaurant7.png'
            ],
            isbar: false,
            reservable: false
        },
        {
            title: 'Mikado Japanese Teppan Yaki',
            type: 'Japonés',
            images: [
                '/assets/img/restaurant7.png',
                '/assets/img/restaurant2.png',
                '/assets/img/restaurant1.png',
                '/assets/img/restaurant3.png',
                '/assets/img/restaurant4.png',
                '/assets/img/restaurant5.png',
                '/assets/img/restaurant6.png'
            ],
            isbar: false,
            reservable: true

        },
        {
            title: 'Mikado Japanese Teppan Yaki',
            type: 'Japonés',
            images: [
                '/assets/img/restaurant7.png',
                '/assets/img/restaurant2.png',
                '/assets/img/restaurant1.png',
                '/assets/img/restaurant3.png',
                '/assets/img/restaurant4.png',
                '/assets/img/restaurant5.png',
                '/assets/img/restaurant6.png'
            ],
            isbar: false,
            reservable: true

        },
        {
            title: 'Mikado Japanese Teppan Yaki',
            type: 'Japonés',
            images: [
                '/assets/img/restaurant7.png',
                '/assets/img/restaurant2.png',
                '/assets/img/restaurant1.png',
                '/assets/img/restaurant3.png',
                '/assets/img/restaurant4.png',
                '/assets/img/restaurant5.png',
                '/assets/img/restaurant6.png'
            ],
            isbar: false,
            reservable: true

        },
        {
            title: 'Sedona Grill',
            type: 'Cocina Estadounidense',
            images: [
                '/assets/img/restaurant3.png',
                '/assets/img/restaurant2.png',
                '/assets/img/restaurant1.png',
                '/assets/img/restaurant4.png',
                '/assets/img/restaurant5.png',
                '/assets/img/restaurant6.png',
                '/assets/img/restaurant7.png'
            ],
            isbar: false,
            reservable: false
        },
        {
            title: 'Gustino Italian Grill',
            type: 'Italiana',
            images: [
                '/assets/img/restaurant4.png',
                '/assets/img/restaurant2.png',
                '/assets/img/restaurant1.png',
                '/assets/img/restaurant3.png',
                '/assets/img/restaurant5.png',
                '/assets/img/restaurant6.png',
                '/assets/img/restaurant7.png'
            ],
            isbar: false,
            reservable: false
        },
        {
            title: 'Bar-sito sport bar',
            type: 'bar',
            images: [
                '/assets/img/restaurant5.png',
                '/assets/img/restaurant2.png',
                '/assets/img/restaurant1.png',
                '/assets/img/restaurant3.png',
                '/assets/img/restaurant4.png',
                '/assets/img/restaurant6.png',
                '/assets/img/restaurant7.png'
            ],
            isbar: true,
            reservable: false
        },
        {
            title: 'Bar Xb Senses',
            type: 'bar',
            images: [
                '/assets/img/restaurant6.png',
                '/assets/img/restaurant2.png',
                '/assets/img/restaurant1.png',
                '/assets/img/restaurant3.png',
                '/assets/img/restaurant4.png',
                '/assets/img/restaurant5.png',
                '/assets/img/restaurant7.png'
            ],
            isbar: true,
            reservable: false
        }
    ];

    private tours = [
        {
            img: '/assets/img/tours_2.png',
            title: 'Xcaret',
            location: 'Playa del Carmen',
            price: 2145
        },
        {
            img: '/assets/img/tours_3.png',
            title: 'Paquete Experiencias Xcaret',
            location: 'Playa del Carmen',
            price: 3900
        },
        {
            img: '/assets/img/tours_4.png',
            title: 'Xcaret Plus - Dolphin Ride',
            location: 'Playa del Carmen',
            price: 3900
        },
        {
            img: '/assets/img/tours_5.png',
            title: 'Tour Xel-Há Todo Incluido',
            location: 'Playa del Carmen',
            price: 3900
        },
        {
            img: '/assets/img/tours_6.png',
            title: 'Tour Xoximilco',
            location: 'Playa del Carmen',
            price: 3900
        },
        {
            img: '/assets/img/tours_7.png',
            title: 'Tour Xel-Há Todo Incluido solo adul...',
            location: 'Playa del Carmen',
            price: 3900
        },
        {
            img: '/assets/img/tours_8.png',
            title: 'Tour Xenses',
            location: 'Playa del Carmen',
            price: 3900
        },
        {
            img: '/assets/img/tours_9.png',
            title: 'Tour Tulum y Xel-Há Todo Incluido',
            location: 'Playa del Carmen',
            price: 3900
        },
        {
            img: '/assets/img/tours_10.png',
            title: 'Tour Xenotes',
            location: 'Playa del Carmen',
            price: 3900
        },
        {
            img: '/assets/img/tours_11.png',
            title: 'Tour Xel-Há Todo Incluido',
            location: 'Playa del Carmen',
            price: 3900
        }
    ];

    public static get Instance() {
        // Obtener instancia unica
        return this._instance || (this._instance = new this());
    }

    public getSections() {
        return [this.sections, this.sections2, this.sections3];
    }

    public getRestaurants() {
        return this.restaurants;
    }

    public getTours() {
        return this.tours;
    }
}

export const MainService = Main.Instance;
